var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIceCream = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M26.6667 10C26.6667 6.31834 23.6817 3.33334 20.0001 3.33334C16.3184 3.33334 13.3334 6.31834 13.3334 10C9.65175 10 6.66675 12.985 6.66675 16.6667C6.66675 20.3483 9.65175 23.3333 13.3334 23.3333C17.0151 23.3333 22.9851 23.3333 26.6667 23.3333C30.3484 23.3333 33.3334 20.3483 33.3334 16.6667C33.3334 12.985 30.3484 10 26.6667 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0633 20H7.93661C6.37828 20 5.67161 21.9483 6.86994 22.9467L8.21161 24.065C10.8749 26.2833 14.0983 27.6783 17.4999 28.145V31.6667H14.1666C12.7849 31.6667 11.6666 32.785 11.6666 34.1667C11.6666 35.5483 12.7849 36.6667 14.1666 36.6667H25.8333C27.2149 36.6667 28.3333 35.5483 28.3333 34.1667C28.3333 32.785 27.2149 31.6667 25.8333 31.6667H22.4999V28.145C25.9016 27.6783 29.1249 26.2833 31.7883 24.065L33.1299 22.9467C34.3283 21.9483 33.6216 20 32.0633 20Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIceCream, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ice-cream.910dfa7e.svg";
export { ForwardRef as ReactComponent };